import type { ReactNode } from 'react'

type Tone = 'neutral' | 'success' | 'info' | 'warning' | 'danger'

const TONES: Record<Tone, string> = {
  neutral: 'bg-subtle border-line text-fg-muted',
  success: 'bg-success-soft border-success-line text-success',
  info: 'bg-accent-soft border-accent-line text-accent',
  warning: 'bg-warning-soft border-warning-line text-warning',
  danger: 'bg-danger-soft border-danger-line text-danger',
}

/** Always carries its own words — the colour is a second signal, never the only
 *  one. */
export function Badge({ tone = 'neutral', children }: { tone?: Tone; children: ReactNode }) {
  return (
    <span
      className={`inline-flex h-5.5 items-center gap-1 rounded-full border px-2 text-2xs leading-none font-semibold whitespace-nowrap ${TONES[tone]}`}
    >
      {children}
    </span>
  )
}
